/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Failedtoupdatecontact3Inputs */

const en_error_failedtoupdatecontact3 = /** @type {(inputs: Error_Failedtoupdatecontact3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed To Update Contact Email`)
};

/**
* | output |
* | --- |
* | "Failed To Update Contact Email" |
*
* @param {Error_Failedtoupdatecontact3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const error_failedtoupdatecontact3 = /** @type {((inputs?: Error_Failedtoupdatecontact3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Failedtoupdatecontact3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_failedtoupdatecontact3(inputs)
});
export { error_failedtoupdatecontact3 as "error_failedToUpdateContact" }